import axios from 'axios';
import { put, takeLatest, call, all } from 'redux-saga/effects';
import {
  FETCH_FREQUENCY_REQUEST,
  FETCH_CLAUSES_REQUEST,
  FETCH_ICONS_REQUEST,
  FETCH_SERVICEINFO_REQUEST,
} from './actionTypes';
import {
  fetchFrequencySuccess,
  fetchFrequencyFail,
  fetchClausesSuccess,
  fetchClausesFail,
  fetchIconsSuccess,
  fetchIconsFail,
  fetchServiceInfoSuccess,
  fetchServiceInfoFail,
} from './actions';

import { logout } from '../Auth/actions';
import { getOptions, processResponse } from '../../Utils/Utils';

const frequencyUrl = '/api/v1/contract/premium/model/frequency';
const beneficiaryClausesUrl = '/api/v1/clause';
const serviceInfoUrl = '/services/info';
const fetchIconsUrl = () => '/api/v1/ir/icon';

// Moved api call into own function (for easy test swapping)
export function fetchFromApi(options) {
  return axios(options)
    .then(response => ({ response }))
    .catch(error => ({ error }));
}

function* frequencies() {
  const { response, error } = yield call(fetchFromApi, getOptions({ url: frequencyUrl }));

  if (response) {
    const { data } = response;
    yield put(fetchFrequencySuccess(data));
  } else {
    try {
      if (error.response.status === 401) yield put(logout());
      if (error.response.status === 403) yield put(logout());
    } finally {
      yield put(fetchFrequencyFail(error));
    }
  }
}

// /api/v1/clause?_fields=rec_name
function* beneficiaryClauses() {
  const params = {
    _fields: 'rec_name',
  };
  const { response, error } = yield call(fetchFromApi, getOptions({ url: beneficiaryClausesUrl, params }));

  if (response) {
    const { data } = response;
    yield put(fetchClausesSuccess(data));
  } else {
    try {
      if (error.response.status === 401) yield put(logout());
      if (error.response.status === 403) yield put(logout());
    } finally {
      yield put(fetchClausesFail(error));
    }
  }
}

// ICONS
function* fetchIcons() {
  const { response, error } = yield call(fetchFromApi, getOptions({ url: fetchIconsUrl() }));
  const { type, data, alerts } = processResponse({ response, error });
  switch (type) {
    case 'success':
      yield put(fetchIconsSuccess({ data }));
      break;
    case 'fail':
      yield put(fetchIconsFail({ error: alerts }));
      break;
    case 'logout':
      yield put(logout());
      break;
    default:
      break;
  }
}

function* serviceInfo() {
  const { response, error } = yield call(fetchFromApi, getOptions({ url: serviceInfoUrl }));
  if (response) {
    const { data } = response;
    yield put(fetchServiceInfoSuccess(data));
  } else {
    yield put(fetchServiceInfoFail(error));
  }
}

function* watchSystem() {
  yield all([
    yield takeLatest(FETCH_FREQUENCY_REQUEST, frequencies),
    yield takeLatest(FETCH_CLAUSES_REQUEST, beneficiaryClauses),
    yield takeLatest(FETCH_ICONS_REQUEST, fetchIcons),
    yield takeLatest(FETCH_SERVICEINFO_REQUEST, serviceInfo),
  ]);
}

export default watchSystem;
